import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'prevButton', 'nextButton'];
  static values = {
    duration: { type: Number, default: 1200 },
  };

  #animationFrameId = null;

  connect() {
    this.updateButtons();
  }

  disconnect() {
    if (this.#animationFrameId) {
      cancelAnimationFrame(this.#animationFrameId);
      this.#animationFrameId = null;
    }
    this.containerTarget.style.scrollSnapType = '';
  }

  scrollPrev() {
    this.#animateScrollBy(-this.#scrollAmount);
  }

  scrollNext() {
    this.#animateScrollBy(this.#scrollAmount);
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget;
    const atStart = scrollLeft <= 0;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = atStart;
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = atEnd;
    }
  }

  #animateScrollBy(distance) {
    if (this.#animationFrameId) {
      cancelAnimationFrame(this.#animationFrameId);
    }

    const startPosition = this.containerTarget.scrollLeft;
    const startTime = performance.now();
    const duration = this.durationValue;

    this.containerTarget.style.scrollSnapType = 'none';

    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = this.#easeInOutCubic(progress);

      this.containerTarget.scrollLeft = startPosition + distance * eased;

      if (progress < 1) {
        this.#animationFrameId = requestAnimationFrame(step);
      } else {
        this.#animationFrameId = null;
        this.containerTarget.style.scrollSnapType = '';
      }
    };

    this.#animationFrameId = requestAnimationFrame(step);
  }

  #easeInOutCubic(progress) {
    if (progress < 0.5) return 4 * progress ** 3;

    const remaining = 1 - progress;
    return 1 - 4 * remaining ** 3;
  }

  get #scrollAmount() {
    const firstCard = this.containerTarget.firstElementChild;
    if (!firstCard) return this.containerTarget.clientWidth;

    const gap = parseFloat(getComputedStyle(this.containerTarget).gap) || 0;
    return firstCard.offsetWidth + gap;
  }
}
